export default {
  back: "Atrás",
  connect: "Conectar",
  connectWallet: "Conectar wallet",
  error: "Error",
  migration: "Actualización de Token",
  view: "Ver",
  wallet: "Wallet",
  disconnect: "Desconectar",
  transactions: {
    title: "Transacciones",
    errorMessage: "La transacción no pudo completarse. Verifica la dirección o el balance de tokens disponibles.",
    seeTransaction: "Ver transacción",
    types: {
      APPROVE: "Aprobar",
      MIGRATE: "Actualizar",
    },
    status: {
      PENDING: "Pendiente",
      SUCCESS: "Exitoso",
      REVERTED: "Revertido",
    },
  },
  signature: {
    title: "Firma",
    errorMessage: "La firma no pudo completarse.",
    status: {
      PENDING: "Pendiente",
      SUCCESS: "Exitoso",
      REVERTED: "Revertido",
    },
  },
}
